import {Component, Input} from '@angular/core';
import {
  ActionTypeSelectStrategyService
} from '@app/services/action-type-select-strategy/action-type-select-strategy.service';
import {TransactionTypeCode} from '@app/services/transactionTypes/transaction-type-code';
import {DcpBundleTemplate, TransactionListCta, TransactionType} from '@dcp/configurator';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Product} from '@spartacus/core';

@Component({

  selector: 'dcp-cta-info-page-cta-button',
  templateUrl: './cta-info-page-cta-button.component.html',
  styleUrls: ['./cta-info-page-cta-button.component.scss']
})
export class CtaInfoPageCtaButtonComponent {

  @Input() slmTransactionType: TransactionListCta;
  @Input() bundleTemplate: DcpBundleTemplate;
  @Input() product: Product;

  constructor(
    private actionTypeSelectStrategyService: ActionTypeSelectStrategyService,
    private activeModal: NgbActiveModal,
  ) {
  }

  getIconPath(): string {
    switch (this.slmTransactionType.code) {
      case TransactionTypeCode.ORDER_UPSELL:
        return '../../../../../assets/images/cta-info-page/add-process_blue.svg';
      case TransactionTypeCode.ORDER_NEW:
        return '../../../../../assets/images/cta-info-page/cart-4_blue.svg';
      case TransactionTypeCode.ORDER_NEW_ZERO_VALUE:
        return '../../../../../assets/images/cta-info-page/cart-4_blue.svg';
      case TransactionTypeCode.ORDER_EXTENSION:
        return '../../../../../assets/images/cta-info-page/add-coursebook_blue.svg';
      case TransactionTypeCode.EXTENSION_CONTACT_SUPPORT:
        return '../../../../../assets/images/cta-info-page/add-coursebook_blue.svg';
      case TransactionTypeCode.ORDER_RESTRUCTURE_UPGRADE:
        return '../../../../../assets/images/cta-info-page/add-coursebook_blue.svg';
      case TransactionTypeCode.TDD_ORDER_NEW:
        return '../../../../../assets/images/cta-info-page/cart-4_blue.svg';
      case TransactionTypeCode.TDD_ORDER_NEW_ZERO_VALUE:
        return '../../../../../assets/images/cta-info-page/cart-4_blue.svg';
      case TransactionTypeCode.TDD_UPSELL:
        return '../../../../../assets/images/cta-info-page/add-process_blue.svg';
      case TransactionTypeCode.TDD_EXTENSION:
        return '../../../../../assets/images/cta-info-page/add-coursebook_blue.svg';
      case TransactionTypeCode.UPSELL_CONTACT_SALES_REP:
        return '../../../../../assets/images/cta-info-page/add-process_blue.svg';
      case TransactionTypeCode.UPSELL_CONTACT_SUPPORT:
        return '../../../../../assets/images/cta-info-page/add-process_blue.svg';
      case TransactionTypeCode.UPSELL_CONTACT_PARTNER:
        return '../../../../../assets/images/cta-info-page/add-process_blue.svg';
      case TransactionTypeCode.VIEW_PRICING:
        return '../../../../../assets/images/cta-info-page/add-process_blue.svg';
      case TransactionTypeCode.LEAD_TRIAL:
        return '../../../../../assets/images/cta-info-page/cart-4_blue.svg';
      default:
        break;
    }
  }

  executeAction(): void {
    this.activeModal.close();
    const actionTypeContext = this.actionTypeSelectStrategyService.selectStrategy(
      {actionType: this.slmTransactionType.actionType} as TransactionType,
      this.product,
      this.slmTransactionType,
      this.bundleTemplate,
    );
    actionTypeContext.exec();
  }
}
